import {ageRate} from "./src/AgeRate";

(function ($,Drupal) { // closure
    'use strict';
    Drupal.behaviors.ageRate = ageRate;
}(jQuery,Drupal));
